var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffordabilityEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 2.66675H17.5303C21.8786 2.66675 24.0527 2.66675 25.5626 3.73053C25.9953 4.03532 26.3793 4.39677 26.7031 4.80393C27.8334 6.22497 27.8334 8.27123 27.8334 12.3637V15.7577C27.8334 19.7086 27.8334 21.6839 27.2082 23.2617C26.203 25.7982 24.0773 27.7989 21.3822 28.7449C19.7059 29.3334 17.607 29.3334 13.4092 29.3334C11.0104 29.3334 9.81104 29.3334 8.85312 28.9971C7.31313 28.4566 6.09841 27.3133 5.52403 25.8639C5.16675 24.9623 5.16675 23.8335 5.16675 21.5758V16.0001",
    stroke: "#3F7CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8333 16C27.8333 18.4545 25.8435 20.4444 23.3889 20.4444C22.5012 20.4444 21.4547 20.2889 20.5915 20.5201C19.8247 20.7256 19.2256 21.3247 19.0201 22.0915C18.7889 22.9547 18.9444 24.0012 18.9444 24.8889C18.9444 27.3435 16.9545 29.3333 14.5 29.3333",
    stroke: "#3F7CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.00008C7.15537 5.32581 8.89969 2.66675 9.83333 2.66675M9.83333 2.66675C10.767 2.66675 12.5113 5.32581 13.1667 6.00008M9.83333 2.66675V13.3334",
    stroke: "#3F7CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordabilityEmptyState);
export default __webpack_public_path__ + "static/media/affordability-empty-state.0117a751971d25ec826650a1be89710a.svg";
export { ForwardRef as ReactComponent };